import { locale } from '@trqk/utils';

import { HASHES } from '../../../constants';

export const sectionMap: Record<string, HeaderSection> = {
    totalRoyalties: {
        id: HASHES.REPORTS.TOTAL_ROYALTIES,
        label: locale.enUS.REPORTS.SECTIONS.TOTAL_ROYALTIES.SECTION_TITLE,
        name: 'totalRoyalties',
    },
};

export const sections: HeaderSection[] = [sectionMap.totalRoyalties];

export const sectionIds = sections.map(({ id }: HeaderSection): string => id);

export const totalRoyaltiesSizes = {
    table: {
        tooltipWidth: 560,
        defaultColumnWidth: 80,
        height: 500,
        rowHeight: 40,
        columnWidths: {
            entityName: 150,
            totalEarnings: 100,
            mostRecentEarnings: 100,
        },
    },
};

export const heights = {
    autoSizeOffsetBottom: 200,
    minSectionHeight: 450,
};
